<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <div class="headercc1" style="margin-left: 26px;position: relative;top: 1px;">
        <!-- Tab 1: Kreuzfahrten -->
        <div [class.headercc2]="selectedTab === 'kreuzfahrten'" [class.headercc4]="selectedTab !== 'kreuzfahrten'"
            (click)="selectTab('kreuzfahrten')">
            <div>Kreuzfahrten</div>
        </div>

        <!-- Tab 2: Mit Flug -->
        <div [class.headercc2]="selectedTab === 'mitflug'" [class.headercc3]="selectedTab !== 'mitflug'"
            (click)="selectTab('mitflug')">
            <div>Mit Flug</div>
        </div>
    </div>
    <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <clever-searchlist [mode]="'home'" [icon]="'place'" [title]="'Reiseziele'"
                (sendSelection)="setRes('cruiseregion', $event)" [bottomleftradius]="true" [topleftradius]="true"
                [norightborder]="true" [list]="cruiseregions"></clever-searchlist>
            <clever-searchlist [mode]="'home'" [icon]="'verified'" [title]="'Reedereien'"
                (sendSelection)="setRes('cruisecompanys', $event)" [norightborder]="true" [list]="cruiseCompany"
                [listpriority]="cruiseCompanypriority" [showVc]="true" class="w160p"></clever-searchlist>
            <clever-searchlist [mode]="'home'" [icon]="'directions_boat'" (sendSelection)="setRes('schiffes', $event)"
                [title]="'Schiffe'" [norightborder]="true" [list]="cruiseschiffe" class="w130p"></clever-searchlist>
            <clever-date [start]="start" [end]="end" (selectValue)="selectDateValue($event)" [mode]="'home'"
                class="w300px">
            </clever-date>
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)" [reisende]="myKrzfilters.reisendeResult">
            </clever-traveller>
            <button matTooltip="mehr filter" multilang deeplMode="tooltip" aria-label="Mehr Filter"
                (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="headercc1" style="margin-left: 26px;position: relative;top: 1px;">
        <!-- Tab 1: Kreuzfahrten -->
        <div [class.headercc2]="selectedTab === 'kreuzfahrten'" [class.headercc4]="selectedTab !== 'kreuzfahrten'"
            (click)="selectTab('kreuzfahrten')">
            <div>Kreuzfahrten</div>
        </div>

        <!-- Tab 2: Mit Flug -->
        <div [class.headercc2]="selectedTab === 'mitflug'" [class.headercc3]="selectedTab !== 'mitflug'"
            (click)="selectTab('mitflug')">
            <div>Mit Flug</div>
        </div>
    </div>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="tmp-extrafilter-wraper-mobile w100">
            <div class="gr-btn-mobile">
                <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruiseregion', $event)" [icon]="'place'"
                    [title]="'Reiseziele'" [topleftradius]="true" [norightborder]="true" [nobottomborder]="true"
                    [list]="cruiseregions" class="w50"></clever-searchlist>
                <clever-searchlist [mode]="'nohome'" [icon]="'verified'"
                    (sendSelection)="setRes('cruisecompanys', $event)" [title]="'Reedereien'" [nobottomborder]="true"
                    [toprightradius]="true" [list]="cruiseCompany" [listpriority]="cruiseCompanypriority"
                    [showVc]="true" class="w50"></clever-searchlist>
            </div>
            <clever-date [start]="start" [end]="end" (selectValue)="selectDateValue($event)" [mode]="'nohome'"
                class="w100">
            </clever-date>
            <div class="gr-btn-mobile w100">
                <clever-searchlist [mode]="'nohome'" [icon]="'directions_boat'"
                    (sendSelection)="setRes('schiffes', $event)" [bottomleftradius]="true" [title]="'Schiffe'"
                    [norightborder]="true" [list]="cruiseschiffe" class="w50">
                </clever-searchlist>
                <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"
                    [reisende]="myKrzfilters.reisendeResult">
                </clever-traveller>
            </div>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
            <button matTooltip="mehr filter" multilang deeplMode="tooltip" aria-label="Mehr Filter"
                class="tmp-mehrfilter-mobile" (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext}}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #nohomemodeMobile>
    <ng-container *ngIf="smallVersion else mbfilter">
        <div class="tmp-inputs-wrapper-nohome-mobile">
            <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
                <div class="m05">
                    <span multilang class="smallfilter-title">
                        Kreuzfahrten
                    </span>
                    <div class="smallfilter-body">
                        <span multilang class="smallitem">
                            <clever-date [start]="start" [end]="end" (selectValue)="selectDateValue($event)"
                                [mode]="'nohomesmall'"></clever-date> |
                        </span>
                        <span multilang class="smallitem">
                            <clever-traveller [mode]="'nohomesmall'"></clever-traveller> P |
                        </span>
                    </div>
                </div>
                <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                    <mat-icon fontIcon="search"></mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <div class="tab-wrapper">
            <div class="tab-item" style="border-radius: 10px 0px 0 0;border-right: 0px;"
                [class.active]="activeTab === 'kreuzfahrten'" (click)="setTab('kreuzfahrten')">
                Kreuzfahrten
            </div>
            <div class="tab-item" style="border-radius: 0px 10px 0 0;" [class.active]="activeTab === 'mitflug'"
                (click)="setTab('mitflug')">
                Mit Flug
            </div>
        </div>
        <div class="gr-btn-mobile">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruiseregion', $event)" [icon]="'place'"
                [title]="'Reiseziele'" [topleftradius]="true" [norightborder]="true" [nobottomborder]="true"
                [list]="cruiseregions" class="w50"></clever-searchlist>
            <clever-searchlist [mode]="'nohome'" [icon]="'verified'" (sendSelection)="setRes('cruisecompanys', $event)"
                [listpriority]="cruiseCompanypriority" [title]="'Reedereien'" [nobottomborder]="true"
                [toprightradius]="true" [list]="cruiseCompany" [showVc]="true" class="w50"></clever-searchlist>
        </div>
        <clever-date [start]="start" [end]="end" (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w100">
        </clever-date>
        <div *ngIf="activeTab !== 'kreuzfahrten'" class="gr-btn-mobile w100">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('airports', $event)" [icon]="'flight'"
                [title]="'Abflughafen'" [nobottomborder]="true" [list]="airports" class="w100">
            </clever-searchlist>
        </div>
        <div class="gr-btn-mobile w100">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruisestarthafen', $event)"
                [icon]="'houseboat'" [title]="'Starthafen'" [norightborder]="true" [nobottomborder]="true"
                [list]="startHafenDatas" class="w50"></clever-searchlist>
            <clever-searchlist [mode]="'nohome'" [icon]="'houseboat'"
                (sendSelection)="setRes('cruisezielhafen', $event)" [title]="'Zielhafen'" [nobottomborder]="true"
                [list]="ziehlHafenDatas" [showVc]="true" class="w50">
            </clever-searchlist>
        </div>
        <div class="gr-btn-mobile w100">
            <clever-searchlist [title]="'Reisedauer'" [icon]="'timelapse'" [list]="reiseDauer" [singleSelect]="true"
                [hideSearch]="true" (sendSelection)="cruisedurationresult($event)" class="w50">
            </clever-searchlist>

            <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"
                [reisende]="myKrzfilters.reisendeResult">
            </clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span multilang>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <div class="tab-wrapper">
            <div class="tab-item" style="border-radius: 10px 0px 0 0;border-right: 0px;"
                [class.active]="activeTab === 'kreuzfahrten'" (click)="setTab('kreuzfahrten')">
                Kreuzfahrten
            </div>
            <div class="tab-item" style="border-radius: 0px 10px 0 0;" [class.active]="activeTab === 'mitflug'"
                (click)="setTab('mitflug')">
                Mit Flug
            </div>
        </div>
        <div class="gr-btn-mobile">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruiseregion', $event)" [icon]="'place'"
                [title]="'Reiseziele'" [nobottomborder]="true" [list]="cruiseregions" class="w50"></clever-searchlist>
            <clever-searchlist [mode]="'nohome'" [icon]="'anchor'" (sendSelection)="setRes('cruisecompanys', $event)"
                [listpriority]="cruiseCompanypriority" [title]="'Reedereien'" [nobottomborder]="true"
                [list]="cruiseCompany" [showVc]="true" class="w50"></clever-searchlist>
        </div>
        <clever-date [start]="start" [end]="end" (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w100">
        </clever-date>
        <div *ngIf="activeTab !== 'kreuzfahrten'" class="gr-btn-mobile w100">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('airports', $event)" [icon]="'flight'"
                [title]="'Abflughafen'" [nobottomborder]="true" [list]="airports" class="w100">
            </clever-searchlist>
        </div>
        <div class="gr-btn-mobile w100">
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruisestarthafen', $event)"
                [icon]="'houseboat'" [title]="'Starthafen'" [norightborder]="true" [nobottomborder]="true"
                [list]="startHafenDatas" class="w50"></clever-searchlist>
            <clever-searchlist [mode]="'nohome'" [icon]="'houseboat'"
                (sendSelection)="setRes('cruisezielhafen', $event)" [title]="'Zielhafen'" [nobottomborder]="true"
                [list]="ziehlHafenDatas" [showVc]="true" class="w50">
            </clever-searchlist>
        </div>
        <div class="gr-btn-mobile w100">
            <clever-searchlist [title]="'Reisedauer'" [icon]="'timelapse'" [list]="reiseDauer" [singleSelect]="true"
                [hideSearch]="true" (sendSelection)="cruisedurationresult($event)" class="w50">
            </clever-searchlist>
            <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"
                [reisende]="myKrzfilters.reisendeResult">
            </clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span multilang>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilter>
    <app-cruiseextrafilters [mode]="'home'" class="w100 max1050" (closeModal)="openclosemore()">
    </app-cruiseextrafilters>
</ng-template>